import React from 'react';

import Tag from './styles';
import { Props, DefaultProps } from './shape';

const Sidebar = ({ children, ...otherProps }) => {
  return (
    <Tag className="sidebar-page" {...otherProps}>
      {children}
    </Tag>
  );
};

Sidebar.propTypes = Props;
Sidebar.defaultProps = DefaultProps;

export default Sidebar;
